<template>
  <div v-if="details.length">
    <VDataTable
      :headers="headers"
      :items="details"
      :must-sort="true"
      hide-actions
      no-data-text="Não há dados a serem exibidos"
      item-key
      class="my-4"
    >
      <template slot="items" slot-scope="props">
        <td>{{ dateFormat(props.item.updatedAt) }}</td>
        <td>{{ timeProcess(props.item)  || "0.00" }}</td>
        <td>{{ distributor }}</td>
        <td>{{ props.item.payload.iccid || "-" }}</td>
        <td>{{ getType(props.item.type) }}</td>
        <td>{{ getStatus(props.item.status) }}</td>
        <td>
          <Payload :payload="props.item.payload" title="Payload unitário" />
        </td>
        <td>
          <Reason :reason="props.item.reason" />
        </td>
      </template>
    </VDataTable>
  </div>
</template>

<script>
import { formatBRDateTime } from "utils/date";
export default {
  components: {
    Reason: () => import("../modal/Reason"),
    Payload: () => import("../modal/Payload"),
  },
  data() {
    return {
      currentPage: "",
      modal: null,
      headers: [
        { text: "Data processamento", value: "updatedAt", sortable: false },
        { text: "Tempo de processamento", value: "duration", sortable: false },
        { text: "Distribuidor", value: "distributor", sortable: false },
        { text: "Iccid", value: "iccid", sortable: false },
        { text: "Tipo", value: "type", sortable: false },
        { text: "Status", value: "status", sortable: false },
        { text: "Payload", value: "payload", sortable: false },
        { text: "Motivo", value: "reason", sortable: false },
      ],
    };
  },
  props: {
    details: {
      type: Array,
      default: () => [],
    },
    distributor: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    getStatus(status) {
      switch (status) {
        case "WAITING_PROCESS":
          return "Aguardando Processamento";
        case "IN_PROCESS":
          return "Em processamento";
        case "WAITING_BILLING":
          return "Aguardando Faturamento";
        case "WAITING_DASHBOARD":
          return "Aguardando Dashboard";
        case "DASHBOARD_PROCESSED":
          return "Processado no Dashboard";
        case "ERROR":
        case "ERROR_PROCESS":
          return "Erro ao processar";
        case "SUCCESS":
          return "Sucesso ao processar";
        default:
          return "-";
      }
    },
    getType(type) {
      switch (type) {
        case "BILLED":
          return "Faturado";
        case "ON_DB":
          return "Em DB";
        case "ON_PLACE":
          return "Em PDV";
        case "ON_SALESMAN":
          return "Em vendedor";
        case "ACTIVATED":
          return "Ativado";
        case "RETURNED_DB":
          return "Devolvido DB";
        case "RETURNED_PDV":
          return "Devolvido PDV";
        case "RETURNED_SALESMAN":
          return "Devolvido vendedor";
        case "TOPUP_SIMCARD":
          return "Recarga";
        case "FIRST_TOPUP":
          return "Primeira recarga";
        case "SECOND_TOPUP":
          return "Segunda recarga";

        default:
          return "-";
      }
    },
    dateFormat(date) {
      return formatBRDateTime(date);
    },
    timeProcess(item) {
      return (
        (new Date(item.updatedAt) - new Date(item.createdAt)) /
        60000
      ).toFixed(2);
    },
  },
};
</script>
